// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-csv-link {
  border: 1px solid #000;
  border-radius: 0.25rem;
}
.download-csv-link:hover {
  background-color: #000;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/DownloadCSV/DownloadCSV.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,sBAAA;AACJ;AAAI;EACI,sBAAA;EACA,WAAA;AAER","sourcesContent":[".download-csv-link {\n    border: 1px solid #000;\n    border-radius: 0.25rem;\n    &:hover {\n        background-color: #000;\n        color: #fff;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
